
define('modules/application/wizard/steps/zoneStep/complexZoneStep/intrusionDetectionZoneStep/zoneCollection',[
  'app',
  // Libs
  'backbone',
  'jqueryUi',
  //Class
  '../zoneCollection',
  './zoneModel'
],function (app, Backbone, jQueryUi, ZoneCollection, ZoneModel) {

  var intrusionDetectionZoneStepZoneCollection = ZoneCollection.extend({
    addConstructors                       : function()  {
      ZoneCollection.prototype.addConstructors.apply(this);
      this.ZoneModel = ZoneModel;
    }
  });

  // Required, return the module for AMD compliance
  return intrusionDetectionZoneStepZoneCollection;

});